import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full bg-white/85 backdrop-blur-xl border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center gap-3 group"
        >
          <span className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight group-hover:text-slate-700 transition-colors">
            دوائي
          </span>
        </Link>

        <div className="hidden sm:flex items-center gap-2 text-sm font-bold tracking-tight text-slate-500">
          <span>منصة رقابية للأدوية</span>
        </div>
      </div>
    </header>
  );
}
